import { render, staticRenderFns } from "./broadcastings.vue?vue&type=template&id=6b725d31&scoped=true&"
import script from "./broadcastings.vue?vue&type=script&lang=js&"
export * from "./broadcastings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b725d31",
  null
  
)

export default component.exports